module.exports = __webpack_public_path__ + "static/media/NHL_Eastern_Conference.d3c96062.svg";